<template>
    <div>
        <div class="mx-auto w-full max-w-screen-2xl pt-0 pb-40 px-8" :key="ramKey" v-if="contacts && contacts.loaded">
            <div class="flex space-x-8" v-if="rams">
                <div class="flex-1">
                    <div class="sticky top-0 bg-white -mx-2 pt-4 px-2 mb-px z-50">
                        <div class="flex flex-1">
                            <div class="flex-1">
                                <!-- RAMS Title. -->
                                <input
                                    class="text-2xl font-bold text-gray-900 border-transparent rounded shadow-none px-2 py-1 -ml-2.5 mb-0"
                                    type="text"
                                    :disabled="readonly || rams.readonly"
                                    v-model="rams.title"
                                    @input="saveIt()"
                                    @change="rams.addSnapshot()"
                                    :placeholder="`Risk Assessment Method Statement.r..`"
                                    @keydown.enter.prevent="$emit('change', $event.target.value);$event.target.blur()"
                                >
                                <!-- RAMS Metadata. -->
                                <div class="text-sm text-gray-500">
                                    Id : {{ rams.id }}
                                    <span v-if="rams.revision">• Revision {{ rams.revision || 0 }}</span>
                                </div>
                            </div>
                            <div class="pt-3">
                                <div @click="showRams"
                                     class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                                     style="min-width: 20px;cursor: pointer"
                                     :class="mode==='rams'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                                >RAMS
                                </div>
                                <div @click="showHealthRisks"
                                     class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                                     style="min-width: 20px;cursor: pointer"
                                     :class="mode==='healthRisks'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                                >Health Risks
                                </div>
                                <div @click="showSafetyRisks"
                                     class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                                     style="min-width: 20px;cursor: pointer"
                                     :class="mode==='safetyRisks'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                                >Safety Risks
                                </div>
                                <div @click="showOperatives" v-if="rams.status === 'Approved by Client'"
                                     class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                                     style="min-width: 20px;cursor: pointer"
                                     :class="mode==='operatives'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                                >Attendee's
                                </div>
                            </div>
                        </div>
                        <template v-if="mode==='operatives'">
                            <label class="my-0 py-0 mt-4">Attendees</label>
                            <div
                                class="flex mt-1.5 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold draggable">
                                <div class="w-6 flex-shrink-0"></div>
                                <div class="flex-1 border-l border-r border-gray-200 px-2 py-1">Name</div>
                                <div class="flex-1 border-r border-gray-200 px-2 py-1">Position</div>
                                <div class="w-20 border-r border-gray-200 px-2 py-1">Signature</div>
                                <div class="w-6 flex-shrink-0 ml-2">
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-if="mode==='healthRisks'" class="mt-4">
                        <div v-if="rams && rams.locked"
                             class="rounded-xl m-0 my-4 border-gray-200 border p-4 text-gray-500 italic text-center w-full bg-yellow-50">
                            <i class="fas fa-eye text-yellow-500 mr-4"></i>
                            <span class="text-yellow-600"><strong>RAMS is read-only</strong> - No more changes may be made to this RAMS Health Risks section</span>
                        </div>
                        <rams-risks mode="health" :rams="rams" class="pt-4" :readonly="readonly"></rams-risks>
                    </div>
                    <div v-if="mode==='safetyRisks'" class="mt-4">
                        <div v-if="rams && rams.locked"
                             class="rounded-xl m-0 my-4 border-gray-200 border p-4 text-gray-500 italic text-center w-full bg-yellow-50">
                            <i class="fas fa-eye text-yellow-500 mr-4"></i>
                            <span class="text-yellow-600"><strong>RAMS is read-only</strong> - No more changes may be made to this RAMS Safety Risks section</span>
                        </div>
                        <rams-risks mode="safety" :rams="rams" class="pt-4" :readonly="readonly"></rams-risks>
                    </div>
                    <div v-if="mode==='operatives'" class="mt-0">
                        <draggable :list="currentAttendees" draggable=".draggable" handle=".handle" group="attendees"
                                   @change="save">
                            <rams-attendee v-for="attendee in currentAttendees"
                                           :key="attendee.id"
                                           :attendee="attendee"
                                           :readonly="readonly"
                                           ref="attendees"
                                           :rams="rams"
                                           :contacts="contacts"
                                           @updatedAttendee="save"
                                           @removeAttendee="removeAttendee"
                            ></rams-attendee>
                        </draggable>
                        <div class="flex border-b -mb-px border-gray-200">
                            <div class="w-6 flex-shrink-0">
                                <div class="px-2 py-2 w-5 h-5 flex attendees-center">
                                    <i class="fa fa-plus text-xs text-gray-300" v-if="!readonly"></i>
                                </div>
                            </div>
                            <div class="flex-1 border-l border-r border-gray-200 px-0 py-0">
                <textarea
                    placeholder="Add a new attendee..."
                    class="px-2 py-1 b-0 border-0 hover:z-10 focus:z-20 resize-none text-sm m-0 border-none shadow-none relative"
                    type="text"
                    rows="1"
                    v-if="!readonly"
                    v-model="newAttendee.name"
                    @input="addAttendeeLine"
                ></textarea>
                            </div>
                            <div class="w-6 ml-2 mt-1">
                            </div>
                        </div>
                        <ui-data-grid-item label="Quick action" wide class="mt-5 mx-1"
                                           v-if="currentAttendees.some((i)=> !i.currentAttendees && !i.signatureRequestedAt)">
                            <div class="flex flex-col md:flex-row flex-wrap -m-2">
                                <ui-button-new class="m-2" icon="fas fa-phone"
                                               @click="requestAllSignatures" extra>Request Signatures
                                </ui-button-new>
                            </div>
                        </ui-data-grid-item>
                    </div>

                    <div class="mt-4" v-else-if="mode==='rams'">
                        <div v-if="rams && rams.locked"
                             class="rounded-xl m-0 my-4 border-gray-200 border p-4 text-gray-500 italic text-center w-full bg-yellow-50">
                            <i class="fas fa-eye text-yellow-500 mr-4"></i>
                            <span class="text-yellow-600"><strong>RAMS is read-only</strong> - No more changes may be made to this RAMS Document</span>
                        </div>
                        <!-- Cover Letter. -->
                        <ui-form-section class="pt-4">
                            <ui-date-picker label="Date" name="date"
                                            v-model="rams.date"
                                            :disabled="readonly || rams.readonly"
                                            @input="rams.update()"
                                            class="xl:col-span-6"></ui-date-picker>
                            <ui-input label="Principle Contractor" name="principleContractor"
                                      :disabled="readonly || rams.readonly"
                                      v-model="rams.principleContractor"
                                      @input="saveIt()"
                                      class="xl:col-span-6"></ui-input>
                            <ui-textarea autoresize label="Site Address" name="siteAddress"
                                         :disabled="readonly || rams.readonly"
                                         v-model="rams.siteAddress"
                                         @input="saveIt()"
                                         class="xl:col-span-6"></ui-textarea>
                            <ui-textarea autoresize label="Location of Works" name="locationOfWorks"
                                         :disabled="readonly || rams.readonly"
                                         v-model="rams.locationOfWorks"
                                         @input="saveIt()"
                                         class="xl:col-span-6"></ui-textarea>
                            <ui-input label="Contract Manager" name="contractManager"
                                      :disabled="readonly || rams.readonly"
                                      v-model="rams.contractManager"
                                      @input="saveIt()"
                                      class="xl:col-span-6"></ui-input>
                            <ui-input label="Contract Reference" name="contractReference"
                                      :disabled="readonly || rams.readonly"
                                      v-model="rams.contractReference"
                                      @input="saveIt()"
                                      class="xl:col-span-6"></ui-input>
                            <rams-fields class="col-span-full" :rams="rams"></rams-fields>
                        </ui-form-section>
                    </div>
                </div>
                <div class="w-72 space-y-8 relative pt-4">
                    <div class="w-72 space-y-1 fixed">
                        <rams-action-panel :rams="rams"
                                           :user="user"
                                           @deleted="(e) => $emit('deleted',e)"
                                           @print="print"
                                           @duplicate="duplicate"
                                           :deleteRams="openDeleteModal"
                        ></rams-action-panel>
                        <div
                            style="overflow-y: auto; padding-right:12px; margin-top:12px; padding-top:12px; top:0px; padding-bottom: 12px;"
                            :style="rams && rams.readonly?'height:calc(100vh - 230px)':'height:calc(100vh - 230px)'">
                            <rams-status-panel :rams="rams"></rams-status-panel>
                            <rams-sent-panel :rams="rams" :key="'sent'+ramKey"></rams-sent-panel>
                            <rams-metadata-panel :rams="rams" :key="'meta'+ramKey"></rams-metadata-panel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import {RAMS} from '@models'
import PackageContactSearch from "../../contacts/PackageContactSearch.vue"
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiFormSection from "../../ui/UiFormSection.vue";
import RamsFields from "./RamsFields.vue";
import UiDatePicker from "../../ui/UiDatePicker.vue";
import UiTextarea from "../../ui/UiTextarea.vue";
import UiInput from "../../ui/UiInput.vue";
import RamsRisks from "./RamsRisks.vue";
import RamsActionPanel from "./RamsActionPanel.vue";
import EstimateStatusPanel from "../../estimation/estimates/EstimateStatusPanel.vue";
import user from "../../../services/User";
import RamsStatusPanel from "./RamsStatusPanel.vue";
import moment from "moment/moment";
import DailyBriefingsAttendee from "../daily-briefings/DailyBriefingsAttendee.vue";
import {uuid} from "../../../utils";
import RamsAttendee from "./RamsAttendee.vue";
import RamsMetadataPanel from "./RamsMetadataPanel.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiContainer from "../../ui/UiContainer.vue";
import {debounce} from "lodash";
import RamsSentPanel from "./RamsSentPanel.vue";

export default {
    components: {
        RamsSentPanel,
        UiContainer,
        UiDataGridItem, UiButtonNew,
        RamsMetadataPanel,
        RamsAttendee,
        DailyBriefingsAttendee,
        RamsStatusPanel,
        EstimateStatusPanel,
        RamsActionPanel,
        RamsRisks,
        UiInput,
        UiTextarea,
        UiDatePicker,
        RamsFields,
        UiFormSection, UiDropdownItem, UiDropdownDivider, draggable, PackageContactSearch
    },
    props: {
        packageReference: Number,
        packageName: String,
        item: Object,
        edit: Function,
        removeItem: Function,
        contacts: Array(),
        readonly: false,
    },
    watch: {
        rams: {
            handler(newValue, oldValue) {
                this.item.date = this.rams.date
                this.item.locationOfWorks = this.rams.locationOfWorks
                this.item.contractReference = this.rams.contractReference
                if (this.item.status !== this.rams.status) {
                    this.item.status = this.rams.status
                    this.ramKey++
                }
            },
            deep: true,
        },
    },
    data() {
        return {
            currentAttendees: [],
            newAttendee: {
                name: null
            },
            rams: null,
            mode: 'rams',
            iframe: false,
            ramKey: 0,
            saveIt: debounce(this.save, 400, {leading: true, maxWait: 3000}),
        }
    },
    computed: {
        user() {
            return user
        }
    },
    methods: {
        requestAllSignatures() {
            this.$modals.open('rams-multiple-signature-request', {
                title: `Send signature request to all attendees not yet requested`,
                contacts: this.contacts,
                attendees: this.rams.attendees,
                handle: async (data, modal) => {
                    let requests = [];
                    data.forEach((i) => {
                        if (i.to) {
                            requests.push(this.rams.requestSignature(i.id, i.to))
                        }
                    })
                    await Promise.all(requests).then(async () => {
                        let ndb = await RAMS.find(this.rams.packageReference, this.rams.id)
                        Object.assign(this.rams, ndb)
                        this.currentAttendees = this.rams.attendees;
                        modal.close()
                    })
                }
            })

        },
        addAttendeeLine() {
            if (!this.newAttendee.name) return
            this.currentAttendees.push({
                id: uuid(),
                name: this.newAttendee.name,
                position: '',
            });
            this.save();
            this.newAttendee.name = ''
            this.$nextTick(() => {
                const inputField = this.$refs.attendees[this.$refs.attendees.length - 1].$refs.name
                let val = inputField.value;
                inputField.focus();
                inputField.value = val;
            })
        },
        removeAttendee(e) {
            this.currentAttendees = this.currentAttendees.filter(attendee => attendee.id !== e.id);
            this.save();
        },
        save() {
            this.rams.attendees = this.currentAttendees;
            this.rams.save();
        },
        showRams() {
            this.mode = 'rams'
        },
        showHealthRisks() {
            this.mode = 'healthRisks'
        },
        showSafetyRisks() {
            this.mode = 'safetyRisks'
        },
        showOperatives() {
            this.mode = 'operatives'
        },
        openDeleteModal() {
            const title = 'Are you sure you want to remove ' + this.rams.contractReference + '?'
            const description = 'You are removing ' + this.rams.contractReference + '. Are you sure you want to do this?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

                this.$emit('deleted')
            });
        },
        duplicate(rams) {
            this.$emit('duplicate', rams)
        },
        print() {
            if (!this.iframe) {
                this.iframe = document.createElement('iframe')
                this.iframe.setAttribute('style', 'display:none')
                this.iframe.src = ""
                this.iframe.name = 'pdf'
                this.iframe.onload = () => {
                    this.$nextTick(() => {
                            setTimeout(() => {
                                const pdfFrame = window.frames["pdf"]
                                pdfFrame.focus()
                                pdfFrame.print()
                            }, 100)
                        }
                    )
                }
                document.body.appendChild(this.iframe)
            }
            this.iframe.src = this.rams.getPrintableUrl() + '?time=' + moment().format('x')
        },
        async updateFromListener(data) {
            if (data.operation === 'updateAggregate') {
                if ((data.aggregate.type === 'RAMS') && (data.aggregate.id === this.rams.id)) {
                    Object.assign(this.rams, data.aggregate.data)
                    Object.assign(this.item, data.aggregate.data)
                }
            }
        },
    },
    async mounted() {
        if (this.item) {
            this.rams = await RAMS.find(this.packageReference, this.item.id)
            this.currentAttendees = this.rams.attendees;
        }
        if (this.rams) {
            User.registerAggregate({'type': 'RAMS', 'id': this.rams.id}, this.updateFromListener)
        }
    },

}
</script>
